var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    { attrs: { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" } },
    [
      _c(
        "g",
        { attrs: { stroke: "#424256", fill: "none", "fill-rule": "evenodd" } },
        [
          _c("circle", {
            attrs: { "stroke-width": "1.4", cx: "8", cy: "8", r: "7.3" }
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M7.384 9.42c-.04-.288-.03-.552.03-.792s.148-.46.264-.66c.116-.2.248-.386.396-.558.148-.172.288-.34.42-.504a3.37 3.37 0 0 0 .33-.486c.088-.16.132-.332.132-.516 0-.288-.086-.52-.258-.696-.172-.176-.41-.264-.714-.264-.248 0-.472.056-.672.168a2.28 2.28 0 0 0-.564.456L5.98 4.86c.256-.304.56-.554.912-.75a2.4 2.4 0 0 1 1.188-.294c.32 0 .616.042.888.126.272.084.508.21.708.378.2.168.354.376.462.624.108.248.162.536.162.864 0 .256-.046.486-.138.69a3.169 3.169 0 0 1-.342.582 6.13 6.13 0 0 1-.438.528 4.34 4.34 0 0 0-.42.528c-.124.184-.224.38-.3.588-.076.208-.098.44-.066.696H7.384zm-.276 1.788c0-.272.084-.496.252-.672a.842.842 0 0 1 .636-.264c.256 0 .47.088.642.264.172.176.258.4.258.672a.922.922 0 0 1-.258.672.861.861 0 0 1-.642.264.842.842 0 0 1-.636-.264.934.934 0 0 1-.252-.672z",
              "stroke-width": ".2",
              fill: "#424256"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }